import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TopicSection() {
  return (
    <section className="mx-auto max-w-content px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div>
          <span className="text-xs font-medium tracking-[0.2em] text-accent-600">TOPICS</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            文化专题
          </h2>
        </div>
        <p className="text-sm text-foreground-500 max-w-md">
          围绕持续更新的文化主题，把分散的资讯编织成可阅读的脉络。
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {topics.map((topic, index) => (
          <Link
            key={topic.id}
            to={`/topic/${topic.id}`}
            className={`group relative rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer ${
              index === 0 ? "md:col-span-2 h-72 md:h-80" : "h-64"
            }`}
          >
            <img
              src={topic.cover}
              alt={topic.title}
              title={`${topic.title}专题 - 黑人文化资讯`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/55 to-primary-950/10" />
            <div className="relative z-10 h-full flex flex-col justify-end p-5 md:p-7">
              <span className="self-start text-xs px-3 py-1 rounded-full bg-accent-500 text-secondary-950 font-medium mb-3 whitespace-nowrap">
                专题 · {topic.articleIds.length} 篇
              </span>
              <h3 className={`font-heading font-bold text-background-50 ${index === 0 ? "text-2xl md:text-3xl" : "text-xl md:text-2xl"}`}>
                {topic.title}
              </h3>
              <p className="text-sm text-background-300 mt-1">{topic.subtitle}</p>
              <p className="text-sm text-background-200/90 mt-3 leading-relaxed line-clamp-2 max-w-2xl">
                {topic.intro}
              </p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-accent-400">
                进入专题
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}